import { ResponsiveStateEnteringEventArgs as ResponsiveStateEnteringEventArgs_internal } from "./ResponsiveStateEnteringEventArgs";
/**
 * Information about the entering action.
*/
var IgrResponsiveStateEnteringEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrResponsiveStateEnteringEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrResponsiveStateEnteringEventArgs.prototype.createImplementation = function () {
        return new ResponsiveStateEnteringEventArgs_internal();
    };
    Object.defineProperty(IgrResponsiveStateEnteringEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrResponsiveStateEnteringEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrResponsiveStateEnteringEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrResponsiveStateEnteringEventArgs;
}());
export { IgrResponsiveStateEnteringEventArgs };
//# sourceMappingURL=igr-responsive-state-entering-event-args.js.map
